import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'vpfa-hidden-feature',
  template: ` <span>This path works only when TestFlag feature flag is enabled</span> `,
  styles: [``],
})
export class HiddenPathFeatureComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
